export const ERROR_OUTLINE_ICON_PATH = 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 '
    + '12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8';
export const REPORT_PROBLEM_OUTLINED_ICON_PATH = 'M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z';
export const STATUS_CUE_FONT_WEIGHT = 600;

const ICON_SIZE = '1.25em';
const ICON_GAP = '0.25em';
const ICON_BASELINE_OFFSET = '-0.25em';

function iconMaskOf(iconPath) {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="${iconPath}"/></svg>`;

    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}

export function createLeadingStatusIcon(iconPath) {
    const mask = iconMaskOf(iconPath);

    return {
        content: '""',
        display: 'inline-block',
        flexShrink: 0,
        width: ICON_SIZE,
        height: ICON_SIZE,
        marginInlineEnd: ICON_GAP,
        verticalAlign: ICON_BASELINE_OFFSET,
        backgroundColor: 'currentColor',
        WebkitMaskImage: mask,
        maskImage: mask,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
    };
}

export default function createStatusTextCue(iconPath) {
    return {
        fontWeight: STATUS_CUE_FONT_WEIGHT,
        '&::before': createLeadingStatusIcon(iconPath),
    };
}
